import { departmentColorMapping } from './utils';

export { departmentColorMapping };
export { default as AvatarText } from './AvatarText';
export { default as NotContactFound } from './NotContactFound';
export { default as ChatAvatar } from './ChatAvatar';
export { default as Contact } from './Contact';
export { default as MessageLike } from './MessageLike';
export { default as Message } from './Message';
export { default as Messages } from './Messages';
export { default as Action } from './Action';
export { default as SelectedAttachment } from './SelectedAttachment';
export { default as MessageSending } from './MessageSending';
